// extracted by mini-css-extract-plugin
export default {"cross":"CloseButton_cross__ZJBE9","alignRight":"CloseButton_alignRight__fUcuS"};